import './blog-carousel.css';
import SwiperCarousel from '../utils/swiper-carousel';

export default () => {
  function init() {
    const swiperSelectors = document.querySelectorAll('.blog-carousel');

    // Go through each element
    swiperSelectors.forEach((swiperSelector, index) => {
      // Add a swiper-slider class with an index
      swiperSelector.classList.add(`swiper-slider-${index}`);

      // Get the values of attributes data-*
      const enabled = swiperSelector.dataset.enableScrollbar || null;
      const hide = swiperSelector.dataset.scrollbarHide || false;
      const dragSize = swiperSelector.dataset.dragSize || 'auto';

      // Swiper instance
      return new SwiperCarousel(`.swiper-slider-${index}`, {
        spaceBetween: 15,
        slidesPerView: 'auto',
        allowTouchMove: true,
        watchOverflow: true,
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
          dragSize,
          hide,
          enabled,
        },
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          640: {
            spaceBetween: 20
          }
        },
      });
    });
  }
  init();
};
